module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 305
// module chunks = 0